import { MovementsArea, type ViewMode } from './MovementsArea'
import type { TodayBoardData } from './useTodayBoardData'
import type { ScheduleRowCallbacks } from './SplitView'

interface BoardColumnsProps extends ScheduleRowCallbacks {
  data: TodayBoardData
  isToday: boolean
  viewMode: ViewMode
}

export function BoardColumns({ data, viewMode, onRowClick, onCheckIn, onCheckOut, onRegister, onShowDetails }: BoardColumnsProps) {
  return (
    <div className="h-full min-h-0">
      <MovementsArea
        arriving={data.schedule.arriving}
        departing={data.schedule.departing}
        movements={data.schedule.movements}
        viewMode={viewMode}
        onRowClick={onRowClick}
        onCheckIn={onCheckIn}
        onCheckOut={onCheckOut}
        onRegister={onRegister}
        onShowDetails={onShowDetails}
      />
    </div>
  )
}
